import React from 'react';
import { useMobxStores } from '@stores/store';
import ImageUnit from '@organisms/media/common/ImageUnit';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

/* 미디어 타입:이미지 */
const MediaScrollData = ({ data }) => {
  const location = useLocation();
  const handleChange = data => {
    let query = queryString.parse(location.search);
    query.detail = data.idx;
    window.location.href = '?detail=' + data.idx;
  };

  return (
    <>
      {data.idx > 0 && (
        <a
          className={' cursor-pointer'}
          onClick={() => {
            handleChange(data);
            return false;
          }}
        >
          <ImageUnit data={data} />
        </a>
      )}
    </>
  );
};

export default MediaScrollData;
